// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  min-height: 100vh;
}

.dashboard-header {
  margin-bottom: 2rem;
}

.dashboard-subtitle {
  font-size: 1.1rem;
  color: rgba(226, 232, 240, 0.75);
  margin-top: 0.5rem;
}

.dashboard-subtitle strong {
  color: var(--primary-light);
  font-weight: 600;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}

.loading-spinner-lg {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(99, 102, 241, 0.1);
  border-radius: 50%;
  border-top-color: var(--primary-color);
  animation: spin 0.8s linear infinite;
}

/* Stat cards use .stat-card from design-system.css */
/* No additional overrides needed - inherits glassmorphism */

/* Widgets and events use .glass-panel from design-system.css */
.widget-header h3 {
  margin: 0;
  font-size: 1.25rem;
}

.widget-content {
  margin-top: 1rem;
}

.events-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.event-item {
  width: 100%;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/* ============ LIGHT THEME OVERRIDES ============ */
[data-theme="light"] .dashboard h1,
[data-theme="light"] .dashboard h2,
[data-theme="light"] .dashboard h3 {
  color: #1e293b;
}

[data-theme="light"] .dashboard p,
[data-theme="light"] .dashboard-card p {
  color: #475569;
}

[data-theme="light"] .dashboard-card h3 {
  color: #1e293b;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA,qDAAqD;AACrD,4DAA4D;;AAE5D,+DAA+D;AAC/D;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA,oDAAoD;AACpD;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".dashboard {\n  min-height: 100vh;\n}\n\n.dashboard-header {\n  margin-bottom: 2rem;\n}\n\n.dashboard-subtitle {\n  font-size: 1.1rem;\n  color: rgba(226, 232, 240, 0.75);\n  margin-top: 0.5rem;\n}\n\n.dashboard-subtitle strong {\n  color: var(--primary-light);\n  font-weight: 600;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n}\n\n.loading-spinner-lg {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(99, 102, 241, 0.1);\n  border-radius: 50%;\n  border-top-color: var(--primary-color);\n  animation: spin 0.8s linear infinite;\n}\n\n/* Stat cards use .stat-card from design-system.css */\n/* No additional overrides needed - inherits glassmorphism */\n\n/* Widgets and events use .glass-panel from design-system.css */\n.widget-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n}\n\n.widget-content {\n  margin-top: 1rem;\n}\n\n.events-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.event-item {\n  width: 100%;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* ============ LIGHT THEME OVERRIDES ============ */\n[data-theme=\"light\"] .dashboard h1,\n[data-theme=\"light\"] .dashboard h2,\n[data-theme=\"light\"] .dashboard h3 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .dashboard p,\n[data-theme=\"light\"] .dashboard-card p {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .dashboard-card h3 {\n  color: #1e293b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
